import { render } from "./linked-organisations-overview.vue?vue&type=template&id=279ca59d&ts=true"
import script from "./linked-organisations-overview.ts?vue&type=script&lang=ts&external"
export * from "./linked-organisations-overview.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__